import { getPointsConfig, PointsItem } from "@silo/types";
import { Array, pipe } from "effect";
import { isNotNullable } from "effect/Predicate";
import { ExternalLink } from "../link";

interface PointsLinksProps {
  pointsItems: readonly PointsItem[];
}

export function PointsLinks({ pointsItems }: PointsLinksProps): JSX.Element {
  const itemsWithLink = pipe(
    pointsItems,
    Array.map((item) => {
      const config = getPointsConfig(item._tag);

      return { ...config, ...item };
    }),
    Array.flatMap((item) => {
      const { link } = item;

      return isNotNullable(link) ? [{ ...item, link }] : [];
    })
  );

  return (
    <>
      {itemsWithLink.map((item) => {
        const { defaultLabel, link } = item;

        return (
          <ExternalLink size="small" href={link}>
            {defaultLabel} details
          </ExternalLink>
        );
      })}
    </>
  );
}
